/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types"

// react-flatpickr components
import Flatpickr from "react-flatpickr"
import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr"
// react-flatpickr styles
import "flatpickr/dist/flatpickr.css"

// Material Kit 2 React components
import MDInput from "components/MDInput"

function MKDatePicker({ input, ...rest }) {
  return (
    <Flatpickr
      {...rest}
      render={({ defaultValue }, ref) => <MDInput {...input} defaultValue={defaultValue} inputRef={ref} />}
    />
  )
}

// Setting default values for the props of MKDatePicker
MKDatePicker.defaultProps = {
  input: {},
}

// Typechecking props for the MKDatePicker
MKDatePicker.propTypes = {
  input: PropTypes.objectOf(PropTypes.any),
}
flatpickr.localize(French)
export default MKDatePicker
